// extracted by mini-css-extract-plugin
export var phone = "_2j-0";